import React from "react";

const Ourschool = () => {
  return (
    <>
      <div className="our-school">
        <div className="our-row">
          <div className="our-col">
            <h1 className="text-uppercase">About Us</h1>
            <p>
            Bhopal Academy Co-Ed Hr. Sec. School was established in 1995 and has been successfully providing quality education for the past 29 years. As a non-profit organization, the school primarily focuses on nurturing future generations and young minds by fostering education and overall development.

Located at, Naveen Nagar, Bhopal, the school offers classes from Nursery to Class 12. Over the years, Bhopal Academy has consistently delivered outstanding results in Class 10 and Class 12 board examinations. Since its inception, we have produced bright and promising students who are set to make a mark in the future.

At Bhopal Academy, we emphasize academics and believe that with proper guidance and a positive mindset, students can achieve remarkable success in their exams. We are committed to providing quality education, maintaining a balanced teacher-student ratio to ensure personalized attention and effective learning.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Ourschool;
